function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.318,2.204C1.861,1.996 1.321,2.102 0.974,2.465C0.627,2.828 0.547,3.37 0.775,3.818L5.668,13.444C5.75,13.605 6.971,15.999 6.971,15.999C6.971,15.999 5.751,18.393 5.668,18.556L0.775,28.182C0.549,28.629 0.627,29.17 0.972,29.533C1.317,29.896 1.853,30.002 2.311,29.799L30.652,17.194C31.077,17.005 31.352,16.583 31.353,16.117C31.355,15.651 31.083,15.228 30.658,15.036L2.318,2.204ZM9.515,17.64C13.485,17.24 19.973,16.518 19.971,16.07C19.969,15.625 13.511,14.837 9.533,14.394C9.223,13.786 8.422,12.213 8.352,12.077L5.82,7.096L25.703,16.099L5.795,24.954L8.353,19.922L9.515,17.64Z"
});
var SvgSubmit = function SvgSubmit(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubmit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/submit.72a0c7cb.svg";
export { ForwardRef as ReactComponent };